import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'errors.noPermissionsTimedEntry.header',
    defaultMessage: 'Computer says “No”',
  },
  message: {
    id: 'errors.noPermissionsTimedEntry.message',
    defaultMessage: 'Sorry, but you don’t have permission to create timed-entry events.',
  },
});
